"use strict";
// Copyright (c) StrangeBee 2024
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionStatus = void 0;
var ActionStatus;
(function (ActionStatus) {
    ActionStatus["WAITING"] = "Waiting";
    ActionStatus["SUCCESS"] = "Success";
    ActionStatus["FAILURE"] = "Failure";
})(ActionStatus = exports.ActionStatus || (exports.ActionStatus = {}));
